import { render, staticRenderFns } from "./EndEventDetail.vue?vue&type=template&id=c859bba0&"
import script from "./EndEventDetail.vue?vue&type=script&lang=js&"
export * from "./EndEventDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/www/game/xcp-vue-xc01/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('c859bba0')) {
      api.createRecord('c859bba0', component.options)
    } else {
      api.reload('c859bba0', component.options)
    }
    module.hot.accept("./EndEventDetail.vue?vue&type=template&id=c859bba0&", function () {
      api.rerender('c859bba0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/gva-wfd/components/DetailPanel/EndEventDetail.vue"
export default component.exports